export const IMGCATE_GET_TASK_CONF_SUCCESS='IMGCATE_GET_TASK_CONF_SUCCESS';
export const IMGCATE_GET_TASK_CONF_ERROR='IMGCATE_GET_TASK_CONF_ERROR';
//export const IMGCATE_UPDATE_IMGCATE_TYPES='IMGCATE_UPDATE_IMGCATE_TYPES';
export const IMGCATE_UPDATE_QUETIONS='IMGCATE_UPDATE_QUETIONS';
export const IMGCATE_TYPE_SELECTED='IMGCATE_TYPE_SELECTED';
export const IMGCATE_TYPE_DESELECTED='IMGCATE_TYPE_DESELECTED';
export const IMGCATE_UPDATE_ANSWER='IMGCATE_UPDATE_ANSWER';
export const IMGCATE_OPEN_LIGHTBOX='IMGCATE_OPEN_LIGHTBOX';
export const IMGCATE_CLOSE_LIGHTBOX='IMGCATE_CLOSE_LIGHTBOX';
export const IMGCATE_SUBMIT_ERROR='IMGCATE_SUBMIT_ERROR';
export const IMGCATE_SUBMIT_SUCCESS='IMGCATE_SUBMIT_SUCCESS';
export const IMGCATE_SUBMIT_COMPLETED='IMGCATE_SUBMIT_COMPLETED';


// WEBPACK FOOTER //
// ./src/redux/imgCate/actionTypes.js